import * as yup from 'yup'

export const schema = yup.object().shape({
   ufDetran: yup.string().required('Campo obrigatório'),
   tipoRelatorio: yup.string().required('Campo obrigatório'),
   referencia: yup
      .string()
      .required('Campo obrigatório')
      .matches(/^(0[1-9]|1[0-2])\/\d{4}$/, 'Use o formato MM/AAAA')
})